import { ICONS } from 'components/Icon';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { Page } from 'components/Page';
import { PdfViewer } from 'components/PdfViewer/PdfViewer';
import { useEsc } from 'hooks/useEsc';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { doFileShareDirect, NAVIGATE_MODAL_BACK } from 'store/actions';
import { FILE_TYPES } from 'service/file/types';

export const PdfViewerScreen: React.FC<
  ModalScreenProps<ModalScreens.PDFVIEWER>
> = ({ route }) => {
  const dispatch = useDispatch();
  const { title, sourceUrl } = route.params;

  const handleClose = React.useCallback(
    () => dispatch(NAVIGATE_MODAL_BACK()),
    [dispatch],
  );

  useEsc(sourceUrl ? handleClose : undefined);

  if (!sourceUrl) {
    return null;
  }

  const pdfViewerProps = { sourceUrl };

  const shareAction = doFileShareDirect({
    url: sourceUrl,
    title,
    fileType: FILE_TYPES.pdf,
  });

  return (
    <Page
      contentPaddingTop={0}
      contentPaddingBottom={0}
      header={
        <NavigationHeader
          heading={title}
          onPressCloseButton={() => dispatch(NAVIGATE_MODAL_BACK())}
          iconButtonRight={{
            icon: ICONS.ShareOS,
            onPress: () => dispatch(shareAction),
          }}
        />
      }
    >
      <PdfViewer {...pdfViewerProps} />
    </Page>
  );
};
